<template>
  <div id="show">
    <h1 style="
        font-size: 30px;
        font-weight: bolder;
        color: #22cab3;
        margin-top: 50px;
      ">
      Result of {{ id }}
    </h1>

    <div class="childShow">
      <el-card>
        <div slot="header">
          <span class="tableTitle"></span>
          <el-button class="dowload" icon="el-icon-download" @click="dowload()">Dowload</el-button>
        </div>
        <Table :tdata="tableData"></Table>
      </el-card>
    </div>
  </div>
</template>

<script>
function convertToElTableFormat(data) {
  const formattedData = [];

  // 获取所有列名
  const columns = Object.keys(data);
  console.log(columns);
  // 假设以第一个列数据的长度为基准，保证所有列数据的长度一致
  const numRows = data[columns[0]].length;

  for (let i = 0; i < numRows; i++) {
    const row = {};
    for (const column of columns) {
      row[column] = data[column][i];
    }
    formattedData.push(row);
  }

  return formattedData;
}

function convertToCustomFormat(array) {
  const result = [];

  for (let i = 0; i < array.length; i++) {
    for (let j = 0; j < array[i].length; j++) {
      result.push([j, i, array[i][j]]);
    }
  }

  return result;
}

function verticalSum(arr) {
  const num=arr.length
  const n = arr[0].length;
  const result = new Array(n).fill(0);

  for (let i = 0; i < num; i++) {
    for (let j = 0; j < n; j++) {
      result[j] += arr[i][j];
    }
  }

  return result;
}

export default {
  name: "Show",
  components: {},
  data() {
    return {
      id: this.$route.params.id,
      tableData: []
    };
  },
  
  methods: {
    async getTaskInfo() {
      let result = await this.$API.reqGenomeInfo(this.id);
      console.log(result['data']);
        let data = result['data']
        this.tableData = convertToElTableFormat(
          data
        );
    },
    dowload(flag, event) {
      let dowload_url = "http://124.220.197.196:8084/"+`images/blast/${this.id}.csv`;
      window.open(dowload_url);
      let target = event.target;
      target.blur();
    },
  },
  created() {
    this.getTaskInfo();
  },
};
</script>

<style>
#show {
  width: 75%;
  margin: 0 auto;

  text-align: center;

  min-width: 1400px;
}

.dowload {
  font-size: 20px;
  float: right;
  height: 50px;
  color: #fff;
  background-color: #d32f2f;
  border-color: #d32f2f;
}
.dowload:hover {
  background: #df6666;
  border-color: #df6666;
  color: #fff;
}
.childShow {
  margin-top: 30px;
  margin-bottom: 100px;
}
.tableTitle {
  margin-left: 20px;
  /* margin: auto; */
  font-size: 30px;
  font-weight: bold;
}
.showimg {
  /* cursor: zoom-in; */
  width: 80%;
  height: 80%;
  /* width: 80%; */
}
</style>
